<template>
    <div class="app flex-row align-items-center bg-white">
        <div class="container">
            <b-row class="justify-content-center">
                <b-col md="12">
                    <b-card-group>
                        <b-card no-body class="text-white" style="border: none;">
                            <b-card-body class="text-center">
                                <div>
                                    <img src="img/logo.png" class="col-md-12">
                                </div>
                            </b-card-body>
                        </b-card>

                        <b-card no-body md="12" style="border: none;">
                            <b-card-body class="p-4">
                                <b-form @submit.prevent="login">
                                    <h4 class="mb-4 text-center">Introduzca sus datos de usuario</h4>

                                    <div v-if="loginError" class="mx-5 px-3 alert alert-danger" role="alert">
                                        {{loginError}}
                                    </div>

                                    <b-input-group class="px-5 pb-3">
                                        <b-form-input
                                            type="text"
                                            class="form-control"
                                            placeholder="Nombre de Usuario"
                                            autocomplete="username"
                                            v-model="user.username"/>
                                    </b-input-group>

                                    <b-input-group class="px-5 pb-3">
                                        <b-form-input
                                            type="password"
                                            class="form-control"
                                            placeholder="Contraseña"
                                            autocomplete="current-password"
                                            v-model="user.password"/>
                                    </b-input-group>

                                    <b-row class="mt-2 px-5 form-inline">
                                        <b-col cols="6" class="text-left">
                                            <b-checkbox
                                                variant="primary"
                                                name="remember"
                                                v-model="user.remember">Recuérdame
                                            </b-checkbox>
                                        </b-col>
                                        <b-col cols="6" class="text-right">
                                            <router-link :to="{ path: '/forget' }" class="pb-2">
                                                Olvidé mi contraseña
                                            </router-link>
                                        </b-col>
                                    </b-row>

                                    <b-row class="justify-content-center pt-2 mt-2">
                                        <loading v-show="isLogin"/>
                                        <b-button
                                            v-show="!isLogin"
                                            type="submit"
                                            variant="primary"
                                            class="px-5 mr-2 btn btn-pill">Acceder
                                        </b-button>

                                        <div 
                                            id="g_id_onload"
                                            data-client_id="153716011184-guqvpspl66s1put4s8ac3m7q3qibfv0a.apps.googleusercontent.com"
                                            data-context="signin"
                                            data-ux_mode="popup"
                                            data-callback="handleCredentialResponse"
                                            data-auto_prompt="false">
                                        </div>

                                        <div 
                                            class="g_id_signin"
                                            data-type="standard"
                                            data-shape="pill"
                                            data-theme="filled_blue"
                                            data-text="signin_with"
                                            data-size="medium"
                                            data-logo_alignment="left">
                                        </div>
                                    </b-row>
                                </b-form>
                            </b-card-body>
                        </b-card>
                    </b-card-group>
                </b-col>
            </b-row>
        </div>
    </div>
</template>

<script>
    import jwtToken from "../../helpers/jwt-token";
    import {mapActions, mapGetters} from "vuex";
    import VueNotifications from 'vue-notifications';
    import user from "../../helpers/user";

    export default {
        name: 'Login',
        data: () => ({
            user: {
                username: "",
                password: "",
                remember: false,
            },
            path: '',
            isLogin: false,
            loginError: null,
        }),
        mounted() {
            if (this.isLoggedIn && this.authUser()) {
                this.user.username = this.authUser().username;
                this.user.password = this.authUser().password;
            }

            const script = document.createElement("script");
            script.src = "https://accounts.google.com/gsi/client";
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);

            window.handleCredentialResponse = this.handleCredentialResponse;
        },
        methods: {
            ...mapActions([
                'setAuthUser',
                'setRememberUser',
            ]),
            ...mapGetters([
                'isLoggedIn',
                'authUser'
            ]),
            login() {
                this.isLogin = true;

                axios.post('login', this.user)
                    .then((response) => {

                        if (response.status === 200) {

                            this.setAuthUser(response.data.user);
                            user.removeUser();
                            user.setUser(response.data.user);
                            jwtToken.setToken(response.data.token);

                            if (this.user.remember === true) {
                                this.setRememberUser(this.user)
                            }

                            if (!!this.authUser.url && (this.authUser.url !== "/login") && (this.authUser.url !== "/")) {
                                this.$router.push({path: this.authUser.url});
                            } else {
                                this.$router.push({name: this.getDefaultPathByPermissions()});
                            }

                        } else {
                            this.isLogin = false;
                        }
                    })
                    .catch((error) => {
                        this.isLogin = false;
                        if (error.response.status === 420) {
                            this.loginError = 'Su cuenta ha sido desactivada. Póngase en contacto con el Administrador para volverla a activar.';
                        } else if (error.response.status === 421) {
                            this.$router.push({name: 'updatePassword'});
                        } else {
                            this.showErrorMsg();
                        }
                    });
            },
            handleCredentialResponse(response) {
                if (response.credential) {
                    const idToken = response.credential;
                    axios.post('/verify-google-id-token', { idToken })
                    .then((response) => {
                        if (response.status === 200) {
                            this.setAuthUser(response.data.user);
                            user.removeUser();
                            user.setUser(response.data.user);
                            jwtToken.setToken(response.data.token);

                            if (this.user.remember === true) {
                              this.setRememberUser(this.user)
                            }

                            if (!!this.authUser.url && (this.authUser.url !== "/login") && (this.authUser.url !== "/")) {
                              this.$router.push({path: this.authUser.url});
                            } else {
                              this.$router.push({name: this.getDefaultPathByPermissions()});
                            }

                        } else {
                            this.isLogin = false;
                        }
                    })
                    .catch((error) => {
                        this.isLogin = false;
                        if (error.response.status === 420) {
                            this.loginError = 'Su cuenta ha sido desactivada. Póngase en contacto con el Administrador para volverla a activar.';
                        } else if (error.response.status === 421) {
                            this.$router.push({name: 'updatePassword'});
                        } else if(error.response.status === 500) {
                            if (error.response.data === 'Invalid domain for login.') {
                                this.loginError = 'Email inválido.';
                            } else {
                            this.loginError = 'Usuario no encontrado.';
                            }
                        } else{
                            this.showErrorMsg();
                        }
                    });
                } else {
                  console.error("Google sign-in failure");
                }
            },
            getDefaultPathByPermissions() {
                if (this.mixinCheckPermission('CONNECTED_USERS')) {
                    return 'dashboard';
                } else if (this.mixinCheckPermission('QUERY_LIST')) {
                    return 'queriesList';
                } else if (this.mixinCheckPermission('CONSIGNMENT_LIST')) {
                    return 'listConsignments';
                } else if (this.mixinCheckPermission('MEMBER_LIST')) {
                    return 'listPartners';
                } else if (this.mixinCheckPermission('USER_LIST')) {
                    return 'listUser';
                } else {
                    return 'dashboard';
                }
            }
        },
        notifications: {
            showSuccessMsg: {
                type: VueNotifications.types.success,
                title: 'Acceso concedido',
                message: 'Bienvenido a ATA Cloud'
            },
            showErrorMsg: {
                type: VueNotifications.types.error,
                title: 'Acceso denegado',
                message: 'Usuario o contraseña incorrecta'
            }
        }
    }
</script>
<style scoped>
    input {
        border: 0;
        outline: 0;
        background: transparent;
        border-bottom: 1px solid lightgrey;
    }
</style>
